<template>
    <x-modal
        v-if="visible"
        :wWidth="1080"
        @cancel="closeModal"
        @close="closeModal"
        @ok="saveSupportUserCategories"
        okText="Save"
        :resizable="true"
        cancelText="Close"
        :loading="loading">
        <div slot="title">Create Support Category Filter</div>

        <section>
            <div class="mb-2 d-flex justify-content-end">
                <el-button @click="addFilterData"><i class="fas fa-plus"></i> Add</el-button>
            </div>

            <el-table
                :data="createFilterData"
                fit
                style="width: 100%">
                <el-table-column
                    prop="name"
                    label="Name">
                    <template slot-scope="scope">
                        <el-input class="fin-w-full" v-model="scope.row.name"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="users"
                    label="Users">
                    <template slot-scope="scope">
                        <el-select class="w-100" v-model="scope.row.users" multiple filterable clearable>
                            <el-option
                                v-for="(assignee, key) in assignees"
                                :key="assignee.id"
                                :label="_.get(assignee, 'full_name')"
                                :value="assignee.id"
                            ></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="category_filter"
                    label="Category Filters">
                    <template slot-scope="scope">
                        <el-select class="fin-w-100" v-model="scope.row.category_filter" placeholder="Category Filter"
                                   multiple
                                   filterable
                                   clearable>
                            <el-option v-for="(categoryOption, key) in mergedCategoryOptions()" :key="key"
                                       :label="categoryOption"
                                       :value="categoryOption"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Action">
                    <template slot-scope="scope">
                        <a @click="remove(scope.$index, scope.row)">
                            <i class="fas fa-times-circle text-danger ml-3"></i>
                        </a>
                    </template>
                </el-table-column>
            </el-table>
        </section>
    </x-modal>
</template>

<script>
export default {
    name: 'SupportCategoryFilter',
    props: {
        visible: {
            required: true,
            type: Boolean,
        },
        categoryOptions: {
            required: true,
            type: [Array, Object]
        },
        adminCategoryOptions: {
            required: false,
            type: [Array, Object],
        },
        isApi: {
            required: true,
        }
    },
    data() {
        return {
            tableLoading: false,
            loading: false,
            assignees: [],
            createFilterData: []
        }
    },
    watch: {
        'visible': {
            handler(val) {
                if (val) {
                    this.getAssignees()
                    this.getSupportUserCategories()
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
    },
    methods: {
        mergedCategoryOptions() {
            if (this.hasPermissions || this.adminCategoryOptions) {
                return _.merge(this.categoryOptions, this.adminCategoryOptions)
            } else {
                return this.categoryOptions
            }
        },
        closeModal() {
            this.loading = false
            this.isVisible = false
            this.createFilterData = []
            this.$emit("update:visible", false)
            this.$bus.$emit('refresh-support-user-categories')
        },
        getSupportUserCategories() {
            this.loading = true

            this.isApi
                .get(`/api/tickets/support-user-category`)
                .then((res) => {
                    this.createFilterData = res.data
                    this.loading = false
                })
                .catch((error) => {
                    console.log("getSupportUserCategories error ", error)
                    this.loading = false
                })
        },
        saveSupportUserCategories() {
            this.loading = true

            this.isApi
                .post(`/api/tickets/save-support-user-category`, {
                    createFilterData: this.createFilterData
                })
                .then((res) => {
                    swal({
                        title: "Success!",
                        type: "success",
                        text: `Support Category Saved`
                    })

                    this.getSupportUserCategories()
                    this.closeModal()
                })
                .catch((error) => {
                    console.log("saveSupportUserCategories error ", error)
                    this.loading = false
                    swal({
                        title: "Error!",
                        type: "error",
                        text: `Failed to save support category`
                    })
                })
        },
        getAssignees() {
            this.isApi
                .get(`/api/tickets/support-developer-brokers`)
                .then((res) => {
                    this.assignees = res.data
                })
                .catch((error) => {
                    console.log("getAssingees error ", error)
                })
        },
        addFilterData() {
            this.createFilterData.push({
                users: [],
                category_filter: [],
                name: ''
            })
        },
        remove(i, v) {
            const index = this.createFilterData.indexOf(v);

            const removedBrokerTarget = _.get(this.createFilterData, index)

            this.isApi
                .post(`/api/tickets/remove-support-user-category/${_.get(removedBrokerTarget, 'id')}`)
                .then((res) => {

                    this.getSupportUserCategories()

                    swal({
                        title: "Success!",
                        type: "success",
                        text: `Support Category Deleted`
                    })
                })
                .catch((error) => {
                    console.log("saveSupportUserCategories error ", error)

                    swal({
                        title: "Error!",
                        type: "error",
                        text: `Failed to delete support category`
                    })

                    this.loading = false
                })
        },
    }
}
</script>
